import { LISTING_PUBLICATION_ERROR_TEXT_KEY } from './RentalPortalListingPublication.constants'

export function getListingPublicationErrorTextKey(publication) {
  return (
    LISTING_PUBLICATION_ERROR_TEXT_KEY[publication?.last_error?.code] ??
    'RentalPortal.ListingPublicationErrorUnknownKey'
  )
}
